import React from 'react';
import { Link, useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { OtpVerify } from '../components/OtpVerify';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const email = searchParams.get('email') || '';

  if (!email) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col">
      <div className="p-4">
        <Link to="/" className="flex items-center gap-2.5">
          <img src="/logo-navbar.png" alt="CELPIPMax" className="w-9 h-9" />
          <span className="font-[Manrope] font-extrabold text-lg text-slate-900">CELPIPMax</span>
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-neutral-200 p-8" data-testid="verify-email-page">
          <OtpVerify
            email={email}
            autoSend
            onVerified={(data) => {
              applyAuth(data);
              navigate(data.user?.onboarding_completed === false ? '/onboarding' : '/dashboard');
            }}
          />
          <p className="mt-6 text-center text-sm text-neutral-500">
            Wrong account? <Link to="/login" className="text-primary font-medium hover:underline">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
